const preventScroll = () => {
  // const scrollY = window.scrollY;
  document.documentElement.classList.add('no-scroll');
  // Object.assign(document.body.style, {
  //   position: 'fixed',
  //   top: `-${scrollY}px`,
  //   left: '0',
  //   right: '0',
  //   width: '100%',
  //   overflow: 'hidden'
  // });
};

const allowScroll = () => {
  // const scrollY = document.body.style.top;
  // Object.assign(document.body.style, {
  //   position: '',
  //   top: '',
  //   overflow: ''
  // });
  // window.scrollTo(0, parseInt(scrollY || '0') * -1);
  // setTimeout(() => {
    document.documentElement.classList.remove('no-scroll');
  // }, 150);
};